import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";

const features = [
  {
    icon: "bi-heart",
    title: "SKIN SAFE",
    description:
      "Our jewelry is hypoallergenic and skin-safe, crafted with care to ensure comfort for all skin types. Enjoy beautiful, irritation-free wear every day, knowing each piece is designed with your well-being in mind.",
  },
  {
    icon: "bi-gem",
    title: "18K GOLD VERMEIL",
    description:
      "Our jewelry is crafted from premium metals like surgical steel, sterling silver, and thick 18k gold plating, ensuring durability and lasting shine. Experience luxury and quality with every piece, designed to stand the test of time.",
  },
  {
    icon: "bi-diamond",
    title: "AUTHENTIC DIAMONDS",
    description:
      "Our lab-grown diamonds are SGL Certified, ensuring the highest standards of quality and authenticity same like natural diamonds. Each diamond undergoes rigorous testing to guarantee its brilliance and ethical origins. Shine with confidence in every sparkly moment.",
  },
];

const ShopConfidence = () => {
  return (
    <section className="py-5 text-center" style={{background: "#e7e7e7"}}>
      <Container>
        <div className="discover-heading"><span>Shop With</span><h2>Confidence</h2></div>

        <Row className="g-4 justify-content-center">
          {features.map((item, index) => (
            <Col key={index} xs={12} md={6} lg={4}>
              <div className="px-3">
                <div className="mb-3">
                  <i className={`bi ${item.icon}`} style={{ fontSize: "32px" }}></i>
                </div>

                <h6 className="fw-semibold mb-2">{item.title}</h6>

                <p className="text-muted small" style={{ lineHeight: "1.6" }}>
                  {item.description}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ShopConfidence;